import {Component, Inject, OnInit} from '@angular/core';
import {ReportService} from '../../../services/report.service';
import {environment} from '../../../../environments/environment';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  templateUrl: './report-preview-dialog.component.html',
})
export class ReportPreviewDialogComponent implements OnInit {

  pdfSource: string;
  loadComplete = false;

  constructor(private service: ReportService,
              @Inject(MAT_DIALOG_DATA) public data) {
  }

  ngOnInit(): void {
    this.service.generatePreviewKey(this.data.clientId, this.data.type, this.data.year).subscribe(key => {
      this.pdfSource = environment.baseUrl + environment.apiPrefix + 'report/preview/' + key.previewKey;
    });
  }
}
